/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { Button, ModalConfirm } from "@nordcloud/gnui";
import { useShowError } from "~/components/Error/useShowError";
import { showSuccess } from "~/components/Toast";
import {
  generateActionConfirmText,
  generateActionSuccessText,
  useAxios,
} from "~/tools";

type UnassignTeamMemberProps = {
  customerId: string;
  employeeId: string;
  confirmMsg: string;
  deleteCallback?: () => void;
};

function UnassignTeamMember({
  customerId,
  employeeId,
  confirmMsg,
  deleteCallback,
}: UnassignTeamMemberProps) {
  const [isOpen, setIsOpen] = React.useState(false);

  const { showError } = useShowError();
  const { Axios } = useAxios();

  return (
    <>
      <Button
        icon="brokenLink"
        size="sm"
        onClick={() => setIsOpen(true)}
        severity="low"
        ml="0.5rem"
      >
        Unassign
      </Button>
      <ModalConfirm
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        confirm={async () => {
          try {
            await Axios().delete(
              `/customers/${customerId}/employees/${employeeId}`
            );
            setIsOpen(true);
            deleteCallback && deleteCallback();
            showSuccess(generateActionSuccessText(confirmMsg)()("deleted")());
          } catch (e) {
            showError(e.response);
          } finally {
            setIsOpen(false);
          }
        }}
        actionLabel="Unassign"
        contentLabel="Unassign Contact"
      >
        {generateActionConfirmText(confirmMsg)("unassign")()} <br />
      </ModalConfirm>
    </>
  );
}

export { UnassignTeamMember };
